var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.729 2.888C1.46033 2.888 1.235 2.797 1.053 2.615C0.871 2.433 0.78 2.20767 0.78 1.939C0.78 1.67033 0.871 1.445 1.053 1.263C1.235 1.081 1.46033 0.989999 1.729 0.989999C1.989 0.989999 2.21 1.081 2.392 1.263C2.574 1.445 2.665 1.67033 2.665 1.939C2.665 2.20767 2.574 2.433 2.392 2.615C2.21 2.797 1.989 2.888 1.729 2.888ZM2.457 3.837V11H0.975V3.837H2.457Z",
    fill: "#FF0000",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoInfo);
export default __webpack_public_path__ + "static/media/info-info.e8b098f03f245f0a655da359a7f848ff.svg";
export { ForwardRef as ReactComponent };